/**
 * Perfil de entrega — tipos y mapeo desde intención del modal (frontend).
 */

export type DeliveryProfile = 'learning_guide' | 'interactive_class' | 'assessment';

export type MaterialIntent = 'print' | 'interactive' | 'exam';

export const DELIVERY_PROFILE_LABELS: Record<DeliveryProfile, string> = {
  learning_guide: 'Guía de aprendizaje',
  interactive_class: 'Clase interactiva',
  assessment: 'Evaluación',
};

export function deliveryProfileFromIntent(intent: MaterialIntent): DeliveryProfile {
  const map: Record<MaterialIntent, DeliveryProfile> = {
    print: 'learning_guide',
    interactive: 'interactive_class',
    exam: 'assessment',
  };
  return map[intent];
}

export function intentFromDeliveryProfile(profile: DeliveryProfile): MaterialIntent {
  const map: Record<DeliveryProfile, MaterialIntent> = {
    learning_guide: 'print',
    interactive_class: 'interactive',
    assessment: 'exam',
  };
  return map[profile];
}

export function resourceTypeForProfile(profile: DeliveryProfile): 'guide' | 'exam' {
  return profile === 'learning_guide' ? 'guide' : 'exam';
}

export function deliveryFormatForProfile(
  profile: DeliveryProfile,
): 'print' | 'interactive' | undefined {
  if (profile === 'interactive_class') return 'interactive';
  if (profile === 'learning_guide') return 'print';
  return undefined;
}

export function parseDeliveryProfile(
  intentParam: string | null,
  profileParam?: string | null,
): DeliveryProfile | null {
  const profiles: DeliveryProfile[] = ['learning_guide', 'interactive_class', 'assessment'];
  const profile = String(profileParam || '').trim();
  if (profiles.includes(profile as DeliveryProfile)) return profile as DeliveryProfile;
  const intents: MaterialIntent[] = ['print', 'interactive', 'exam'];
  const intent = String(intentParam || '').trim();
  if (intents.includes(intent as MaterialIntent)) return deliveryProfileFromIntent(intent as MaterialIntent);
  return null;
}
